import type { ChatEntryWithSubTables } from "../../../shared/aiSdkMessages";
import { USER_ACTION_TOOLS } from "../../../shared/clientAutoResolvedTools";

export function activityDuration(entries: readonly ChatEntryWithSubTables[]) {
  const first = entries[0];
  if (!first) return 0;
  let end = first.createdAt;
  let waitingMs = 0;
  let waitingEnd = first.createdAt;
  for (const entry of entries) {
    const completedAt =
      entry.toolCall?.completedAt ??
      entry.createdAt + (entry.assistantReasoning?.durationMs ?? 0);
    end = Math.max(end, entry.createdAt, completedAt);
    if (entry.toolCall && USER_ACTION_TOOLS.has(entry.toolCall.toolName)) {
      // Overlapping prompts count as one pause, including time spent waiting for an answer.
      waitingMs += Math.max(
        0,
        completedAt - Math.max(waitingEnd, entry.createdAt)
      );
      waitingEnd = Math.max(waitingEnd, completedAt);
    }
  }
  return Math.max(0, end - first.createdAt - waitingMs);
}
